<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="статус исполнителя"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-item-by-id="getWorkerStatus"
      :get-list="getItems"
      :can-create-catalog="canEditWorkerStatus()"
      :drop-up="dropUp"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <worker-status
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import WorkerStatus from "./WorkerStatus.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "WorkerStatusSelect",
  components: { CatalogSelect, WorkerStatus },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    value: { type: Number, default: null },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getWorkerStatusesSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getWorkerStatus(id) {
      const result = await this.getWorkerStatusById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditWorkerStatus() {
      return this.hasPermission([PERM.CATALOG_WORKER_STATUS_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerStatuses/WorkerStatusSelect.vue